import React from 'react';

import AppBar from 'components/AppBar';
import ModalHeader from 'components/ModalHeader';
import { Desktop, Mobile } from 'components/Responsive';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { PaymentMethod } from 'models/paymentCard';
import CreditCard from 'screens/components/Payment/CreditCard';

import { SubTitle } from './styles';

interface Params {
  originGroup?: string;
  groupId?: string;
  selectedMethod?: PaymentMethod;
  onCloseForm: () => void;
  onAdded: (cardId?: number) => void;
}

const PaymentAddCardContainer = ({ originGroup, groupId, selectedMethod, onCloseForm, onAdded }: Params) => {
  const { t } = useStoreTranslation();
  const flag = selectedMethod
    ? selectedMethod.description.indexOf('american express') > -1
      ? 'amex'
      : selectedMethod.description
    : '';

  return (
    <>
      <Mobile>
        <AppBar goBack={onCloseForm}>
          <h5>{t('payment.cardList.cardListTitle')}</h5>
          <SubTitle>{originGroup}</SubTitle>
        </AppBar>
      </Mobile>

      <Desktop>
        <ModalHeader title={t('payment.cardList.cardListTitle')} onClose={onCloseForm} />
      </Desktop>

      <CreditCard
        tokenizer={selectedMethod?.tokenizer?.toUpperCase()}
        flag={flag}
        groupId={groupId}
        onAdded={onAdded}
      />
    </>
  );
};

export default PaymentAddCardContainer;
